import { render, staticRenderFns } from "./PictureAndText.vue?vue&type=template&id=18d537d1&"
import script from "./PictureAndText.vue?vue&type=script&lang=js&"
export * from "./PictureAndText.vue?vue&type=script&lang=js&"
import style0 from "./PictureAndText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports